import screenShot1 from '../../images/screenshot/1.png'
import screenShot2 from '../../images/screenshot/2.png'
import screenShot3 from '../../images/screenshot/3.jpg'
import screenShot4 from '../../images/screenshot/4.png'
import screenShot5 from '../../images/screenshot/5.png'
import screenShot6 from '../../images/screenshot/6.png'

const products = [
    {
        id:1,
        img: screenShot1,
        icon: "mdi mdi-monitor",
        title: "Fully Responsive",
        description: "It has survived not only five centuries, but also the leap into electronic typesetting."
    },
    {
        id:2,
        img: screenShot2,
        icon: "mdi mdi-code-tags",
        title: "W3c Valid Code",
        description: "It has survived not only five centuries, but also the leap into electronic typesetting."
    },
    {
        id:3,
        img: screenShot3,
        icon: "mdi mdi-tune",
        title: "Easy to customize",
        description: "It has survived not only five centuries, but also the leap into electronic typesetting."
    },
    {
        id:4,
        img: screenShot4,
        icon: "mdi mdi-google-chrome",
        title: "Browser Compatibility",
        description: "It has survived not only five centuries, but also the leap into electronic typesetting."
    },
    {
        id:5,
        img: screenShot5,
        icon: "mdi mdi-tailwind",
        title: "Based On Tailwind Css",
        description: "It has survived not only five centuries, but also the leap into electronic typesetting."
    },
    {
        id:6,
        img: screenShot6,
        icon: "mdi mdi-atom-variant",
        title: "Retina Ready",
        description: "It has survived not only five centuries, but also the leap into electronic typesetting."
    },
]

export default products